import { SeoSettingsForm } from './SeoSettingsForm'
import { SEO_STR as S } from './seoApi'

/**
 * A12.20 — Search Console integratsiyasi. Sayt property + API-kaliti (maxfiy) +
 * qo'lda kiritilgan ko'rsatkichlar (klik/ko'rsatish/CTR/pozitsiya) — seo_gsc_*.
 */
export function SearchConsoleScreen() {
  return (
    <SeoSettingsForm
      screenId="A12.20"
      title={S.searchConsole}
      fields={[
        { key: 'seo_gsc_site', label: S.gscSite, kind: 'text', mono: true, placeholder: 'https://mygram.my/' },
        { key: 'seo_gsc_key', label: S.gscKey, kind: 'secret' },
        { key: 'seo_gsc_clicks', label: S.gscClicks, kind: 'number' },
        { key: 'seo_gsc_impressions', label: S.gscImpressions, kind: 'number' },
        { key: 'seo_gsc_ctr', label: S.gscCtr, kind: 'number' },
        { key: 'seo_gsc_position', label: S.gscPosition, kind: 'number' },
      ]}
    />
  )
}

/**
 * A12.21 — Yandex Webmaster integratsiyasi. Host ID + OAuth-token (maxfiy) + ИКС
 * va indekslangan sahifalar (seo_yandex_*). Token yozib qo'yiladi, o'qib emas.
 */
export function YandexWebmasterScreen() {
  return (
    <SeoSettingsForm
      screenId="A12.21"
      title={S.yandexWebmaster}
      fields={[
        { key: 'seo_yandex_host', label: S.yaHost, kind: 'text', mono: true },
        { key: 'seo_yandex_token', label: S.yaToken, kind: 'secret' },
        { key: 'seo_yandex_sqi', label: S.yaSqi, kind: 'number' },
        { key: 'seo_yandex_indexed', label: S.yaIndexed, kind: 'number' },
      ]}
    />
  )
}
